const dataLayer = window.dataLayer || [];

interface ObjStateModel {
  [index: string]: any;
}

export function getTypePage(): string {
    let type: string = dataLayer[0]?.categoryPage;
    if (!type) {
        if (window.location.pathname.includes("/recherche")) {
            type = "SERP";
        } else if (window.location.pathname.includes("/emplois/")) {
            type = "annonce";
        } else if (window.location.pathname.includes("/home/tunnel")) {
            type = "Home";
        }
    }
    return type;
}

export function getSubTypePage(): string {
    let subType: string = dataLayer[0]?.typePage;
    if (!subType) {
        if (window.location.pathname.includes("/recherche")) {
            subType = "LO-Moteur";
        } else if (window.location.pathname.includes("/tunnel")) {
            subType = "LO-Onboarding";
        }
    }
    return subType;
}

export function getSujetPage(): string {
    return dataLayer[0]?.sujetPage || "Offre";
}
export function getGTMAppState(key: string):any {
    const hwGTMAppState: ObjStateModel = {};
    for (let i = 0; i < window.dataLayer.length; i++) {
      fuseObject(hwGTMAppState, window.dataLayer[i]);
    }
    return hwGTMAppState[key];
}

function fuseObject(old: any, neo: any) {
        if (old) {
            if (neo && typeof neo == "object" && typeof old == "object") {
                for (const key in neo) {
                    // eslint-disable-next-line no-prototype-builtins
                    if (neo.hasOwnProperty(key)) {
                        const k = neo[key];
                        if (old[key]) {
                            if (k && typeof k == "object" && typeof old[key] == "object") {
                                fuseObject(old[key], k);
                            } else {
                                old[key] = k;
                            }
                        } else {
                            old[key] = k;
                        }
                        
                    }
                }
            } else {
                old = neo;
            }
        } else {
            old = neo;
        }
    }